module.exports = __webpack_public_path__ + "img/grey.8b58ee8a.png";